import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { getDetailAppPackageQuery } from '../apis';
import { setFieldAppPackage } from '..';
import { deepClone } from '@tenant/utility/helper/Utils';
import { useDispatch } from 'react-redux';
import queryKeyAppPackage from '../constants/queryKeyAppPackage';

const useGetDetailAppPackage = (id) => {
  const dispatch = useDispatch();

  const getData = useQuery({
    queryKey: queryKeyAppPackage.getDetail(id),
    queryFn: () => getDetailAppPackageQuery(id),
  });

  return getData;
};

export default useGetDetailAppPackage;
